<template lang="pug">
.content
  layoutContainer
    .add-service-container
      .header {{ title }}
      .body
        .service-config
          .config-name 服务名称
          .service-config-detail
            el-input(v-model="serviceName" maxlength="20").input-service-name
        .service-config
          .config-name 所属公司全称
          .service-config-detail
            el-input(v-model="companyName" @focus="checkCompanyName = false" maxlength="200").input-company-name
            .company-name-check(v-show="checkCompanyName") 请输入公司全称
        .service-config
          .config-name 所属分类
          .service-config-detail
            el-select(v-model="categoryOne" :class="{'select-level':isShowLevelThree}" @change="categoryOneChange")
              el-option(v-for="item in  categoryOneList" :key="item.id" :label="item.name" :value="item.id")
            el-select(v-model="categoryTwo" :class="{'select-level':isShowLevelThree}" @change="categoryTwoChange")
              el-option(v-for="item in  categoryTwoList" :key="item.id" :label="item.name" :value="item.id")
            el-select(v-model="categoryThree" v-show="isShowLevelThree")
              el-option(v-for="item in  categoryThreeList" :key="item.id" :label="item.name" :value="item.id")
        .service-config 
          .config-name
          .service-config-detail 
            .submit(@click="submit") {{ submitButton }}
</template>

<script>
import {getCompanyInfoByAdminApi, checkAuth} from '@/api/product'
import {saveServeApi, getServeDetailApi} from '@/api/serve.js'
import {getBusinessListApi} from '@/api/index.js'
import {getCompanyDetailApi} from '@/api/company.js'

export default {
  name: 'ProductDetail',
  components: {},
  data() {
    return {
      isManager: false, //是否是管理员
      isOperator: false, // 是否是运营人员
      title: '',
      submitButton: '',
      checkCompanyName: false,
      isShowLevelThree: false, // 是否展示三级分类
      serviceName: '', // 服务名称
      companyName: '', // 公司全称
      categoryOne: '', // 一级分类
      categoryTwo: '', // 二级分类
      categoryThree: '', // 三级分类
      categoryOneList: [], // 一级分类列表
      categoryTwoList: [
        {
          id: -1,
          name: '下级分类（可选）'
        }
      ], // 二级分类列表
      categoryThreeList: [
        {
          id: -1,
          name: '下级分类（可选）'
        }
      ], // 三级分类列表
      businessList: [],
      serviceTypeList: [] // 服务分类列表
    }
  },
  created() {
    const {serveEdit, serviceId, companyId} = this.$route.query
    this.title = serveEdit === 'true' ? '编辑服务' : '新增服务'
    this.submitButton = serveEdit === 'true' ? '修改' : '提交'

    // 服务分类列表
    getBusinessListApi({type: '服务'}).then(res => {
      this.serviceTypeList = res.data.serviceList
      this.categoryOneList = res.data.serviceList
      if (serveEdit === 'false') {
        this.categoryOne = res.data.serviceList[0].id
        this.categoryOneChange(this.categoryOne)
      }
    })

    // 判断是否是编辑服务，获取服务详情
    serveEdit === 'true' &&
      getServeDetailApi({id: serviceId}).then(res => {
        const {serviceName, companyName, businessList} = res.data
        this.serviceName = serviceName
        this.companyName = companyName
        this.businessList = businessList

        if (this.serviceTypeList) {
          // 一级分类
          const categoryOneResult = this.serviceTypeList.find(item => item.id === businessList[0].id)
          this.categoryOne = categoryOneResult.id
          // 二级分类
          this.categoryTwoList.push(...(categoryOneResult.childrenList || []))
          if (businessList[1]) {
            const categoryTwoResult = this.categoryTwoList.find(item => item.id === businessList[1].id)
            this.categoryTwo = categoryTwoResult.id
            this.categoryThreeList.push(...(categoryTwoResult.childrenList || []))
          } else {
            this.categoryTwo = -1
            const categoryTwoResult = this.categoryTwoList.find(item => item.id === businessList[1].id)
            this.categoryThreeList.push(...(categoryTwoResult.childrenList || []))
          }

          //三级分类
          if (businessList[2]) {
            this.isShowLevelThree = true
            const categoryThreeResult = this.categoryThreeList.find(item => item.id === businessList[2].id)
            this.categoryThree = categoryThreeResult.id
          } else {
            this.categoryThree = -1
          }
        }
      })

    // 判断是否有公司ID
    companyId &&
      getCompanyDetailApi({companyId}).then(res => {
        this.companyName = res.data.companyVo.name
      })

    // 判断是不是管理员
    getCompanyInfoByAdminApi().then(res => {
      if (res.data === null) return
      this.companyName = res.data.name
      this.isManager = true
    })
    if (this.UserInfo && this.UserInfo.id) {
      // 是否是运营
      checkAuth({and: true, authList: [1]}).then(res => {
        this.isOperator = res.code === 200
      })
    } else {
      this.isOperator = false
    }
  },
  methods: {
    // 一级分类
    categoryOneChange(value) {
      const childrenList = this.categoryOneList.find(item => item.id === value).childrenList
      this.categoryTwoList = [
        {
          id: -1,
          name: '下级分类（可选）'
        }
      ]
      this.categoryTwoList.push(...(childrenList || []))
      this.categoryTwo = -1
      this.categoryThree = -1
      this.isShowLevelThree = false

      if (!this.serviceName) {
        const result = this.categoryOneList.find(item => item.id === value)
        this.serviceName = result.name
      }
    },
    // 二级分类
    categoryTwoChange(value) {
      this.categoryThree = -1
      if (value === -1) {
        this.isShowLevelThree = false
        return
      }
      const childrenList = this.categoryTwoList.find(item => item.id === value).childrenList || []
      if (!childrenList.length) return
      this.categoryThreeList = [
        {
          id: -1,
          name: '下级分类（可选）'
        }
      ]
      this.categoryThreeList.push(...childrenList)
      this.isShowLevelThree = true
      if (value !== -1 && !this.serviceName) {
        const result = this.categoryTwoList.find(item => item.id === value)
        this.serviceName = result.name
      }
    },
    submit() {
      if (!this.isManager && !this.isOperator) return
      if (!this.serviceName) {
        this.$dialog.toast('请输入服务名称')
        return
      }
      if (this.companyName === '') {
        this.checkCompanyName = true
        return
      }
      const params = {
        name: this.serviceName,
        id: this.$route.query.serviceId || '',
        companyName: this.companyName,
        businessId: ''
      }
      if (this.categoryThree === -1 || !this.categoryThree) {
        if (this.categoryTwo === -1 || !this.categoryTwo) {
          params.businessId = this.categoryOne
        } else {
          params.businessId = this.categoryTwo
        }
      } else {
        params.businessId = this.categoryThree
      }
      saveServeApi(params).then(res => {
        if (res.code === 200) {
          this.$dialog.toast('保存成功')
          if (this.$route.query.companyId) {
            this.$router.push({
              path: `/companyDetail/${this.$route.query.companyId}`
            })
          } else {
            this.$router.push({
              path: '/serve'
            })
          }
        } else if (res.code === 100003) {
          this.$dialog.toast(res.data)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-service-container {
  min-height: 1050px;
  width: 100%;
  background-color: #fff;
  padding-top: 40px;
  .header {
    padding-left: 63px;
    position: relative;
    height: 24px;
    line-height: 28px;
    font-size: 22px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 60px;
    &::after {
      content: '';
      position: absolute;
      height: 24px;
      width: 3px;
      background-color: #5ad3cd;
      left: 50px;
    }
  }
  .body {
    padding: 0 200px 0 164px;
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    input {
      border-top: none;
      border-left: none;
      border-right: none;
      border-bottom: 2px solid #f1f1f1;
    }
    .service-config {
      min-height: 47px;
      display: flex;
      align-items: flex-start;
      margin-bottom: 50px;

      .config-name {
        width: 108px;
        margin-right: 30px;
        text-align: right;
      }
      .service-config-detail {
        font-size: 18px;
        flex: 1;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: flex-start;
        .input-service-name {
          width: 100%;
          /deep/.el-input__inner {
            width: 700px;
          }
        }
        .input-company-name {
          width: 320px;
        }
        .company-name-check {
          margin-left: 50px;
          color: #f30f03;
          font-size: 18px;
          font-weight: 400;
        }
        .el-select {
          margin-right: 58px;
          &:nth-child(2n) {
            margin-right: 0;
          }
        }
        .select-level {
          margin-bottom: 50px;
        }
        /deep/.el-input__inner {
          border-top: none;
          border-left: none;
          border-right: none;
          border-bottom: 2px solid #f1f1f1;
          width: 320px;
        }
        /deep/.el-textarea__inner {
          height: 200px;
        }
      }
    }
    .submit {
      width: 370px;
      height: 46px;
      background: #5ad3cd;
      border-radius: 4px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 46px;
      cursor: pointer;
    }
  }
}
</style>
